const initialState = {
  config: {
    appLayerConfigDebug: false
  },
}

export default initialState;